import { Crosshair, Flame, Globe2, Radio, Shield, Zap } from 'lucide-react';
import { threatText, type InterfaceLanguage } from '../lib/i18n';

export function ThreatBadge({ level, language = 'en' }: { level: string; language?: InterfaceLanguage }) {
  const tone = level === 'गंभीर' ? 'critical' : level === 'उच्च' ? 'high' : level === 'मध्यम' ? 'medium' : 'low';
  return <span className={`threat-badge ${tone}`}><i />{threatText(language, level)}</span>;
}

export function CategoryIcon({ category, size = 13 }: { category: string; size?: number }) {
  if (category === 'सैन्य गतिविधि') return <Crosshair size={size} />;
  if (category === 'संघर्ष') return <Flame size={size} />;
  if (category === 'कूटनीति') return <Globe2 size={size} />;
  if (category === 'साइबर') return <Zap size={size} />;
  if (category === 'आपदा') return <Radio size={size} />;
  return <Shield size={size} />;
}
